import { render, staticRenderFns } from "./ekleHeader.vue?vue&type=template&id=7a9d2312&scoped=true&"
import script from "./ekleHeader.vue?vue&type=script&lang=js&"
export * from "./ekleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9d2312",
  null
  
)

export default component.exports